import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'he',
    fullName: 'Hebrew',
    nativeName: 'עברית',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "משהו מדהים מגיע",
    landing_subtitle: "ArgVoid הוא סטודיו לפיתוח אפליקציות ומשחקים. הישארו מעודכנים, דברים חדשים בקרוב!",
    select_language: "בחר שפה",
    search_placeholder: "חפש שפות...",
    terms_title: "תנאים והגבלות",
    policy_title: "מדיניות פרטיות",
    cookies_title: "מדיניות עוגיות",
    terms_content: `
        <strong>1. הסכמה לתנאים</strong><br>
        על ידי גישה ל-ArgVoid, תנאים והגבלות אלה מתקבלים. אם תנאים אלה אינם מוסכמים, אין להשתמש בשירות.<br><br>

        <strong>2. שימוש בפלטפורמה</strong><br>
        ArgVoid והיישומים שלה מסופקים "כמות שהם" למטרות מידע ויצירתיות. יש להשתמש בשירות רק למטרות חוקיות.<br><br>

        <strong>3. התנהגות אסורה</strong><br>
        ניצול נקודות תורפה באתר, ספאם או ניסיון גישה לא מורשית לתשתית אסור בהחלט.<br><br>

        <strong>4. כתב ויתור</strong><br>
        הפלטפורמה והשירותים עשויים להשתנות בכל עת ללא הודעה מוקדמת. לא ניתנת אחריות לגבי זמן הפעילות או הזמינות של השירות.
    `,
    policy_content: `
        <strong>1. אוסף מידע</strong><br>
        הפלטפורמה אינה דורשת אימות משתמש או יצירת חשבון בשלב זה. שום מידע מזהה אישי (כגון שמות או כתובות דוא"ל) לא נאסף באופן פעיל מהמבקרים.<br><br>

        <strong>2. שימוש ב-Data</strong><br>
        ניתוח בסיסי ואנונימי עשוי להיאסף כדי להבין את תעבורת האתר ולשפר את היישומים. נתונים אלה אינם מקושרים לזהויות משתמש בודדות.<br><br>

        <strong>3. שירותי צד שלישי</strong><br>
        ניתן להשתמש בספקי צד שלישי עבור שירותי אירוח וניתוח. נוהלי הפרטיות של ספקים אלה בהתאמה קובעים את הנתונים האנונימיים המעובדים בתשתית שלהם.<br><br>

        <strong>4. אבטחת נתונים</strong><br>
        אמצעי אבטחה סבירים מיושמים כדי להגן על הפלטפורמה. עם זאת, שום שיטת שידור דרך האינטרנט אינה מאובטחת לחלוטין.<br><br>
    `,
    cookies_content: `
        <strong>1. מהן קובצי Cookie ואחסון מקומי?</strong><br>
        קובצי Cookie ואחסון מקומי בדפדפן הם קובצי נתונים קטנים המאוחסנים במכשיר כדי לזכור העדפות תצורה לאורך ביקורים.<br><br>

        <strong>2. מטרת שימוש</strong><br>
        דפדפן LocalStorage משמש אך ורק לשמירת הגדרות תצורה, כגון:<br>
        - העדפות שפה<br>
        - תצורת ממשק משתמש (למשל, הגדרות פריסה או ערכת נושא) <br>
        - מטמון יישום זמני<br><br>

        <strong>3. אין מעקב</strong><br>
        קובצי Cookie ואחסון מקומי אינם משמשים למטרות פרסום או מעקב של צד שלישי. כל הנתונים המאוחסנים מיועדים אך ורק לפונקציונליות הליבה של הפלטפורמה.<br><br>

        <strong>4. Control</strong><br>
        ניתן לנקות את נתוני הדפדפן בכל עת דרך הגדרות הדפדפן, אשר יאפסו את כל התצורות המקומיות.
    `,
    cookie_consent_text: "אנו משתמשים בעוגיות בסיסיות כדי להבטיח שהאתר פועל כהלכה, כגון שמירה על ההפעלה שלך פעילה, שמירת העדפת השפה שלך ותצורות מותאמות אישית אחרות.",
    read_policy: "קרא את מדיניות העוגיות",
    support_title: "צור קשר עם התמיכה",
    support_subject_label: "נוֹשֵׂא",
    support_message_label: "הוֹדָעָה",
    support_submit_button: "שלח הודעה",
    support_hint: "הערה: פעולה זו תפתח את אפליקציית הדוא\"ל המוגדרת כברירת מחדל לשליחת ההודעה.",
    support_success_msg: "פותח את אפליקציית האימייל שלך...",
    support_error_msg: "שליחת ההודעה נכשלה. אנא נסה שוב מאוחר יותר.",
    explorer_title: "חוֹקֵר",
    history_title: "הִיסטוֹרִיָה",
    animation_title: "הַנפָּשָׁה",
    config_title: "תְצוּרָה",
    tool_mouse: "בחר (Ctrl+M)",
    tool_brush: "מברשת (Ctrl+B)",
    tool_brush_mode: "מצב החלפת מצב (מוצק/נקה)",
    tool_eraser: "מחק (Ctrl+E)",
    tool_brush_size: "התאם את גודל המברשת",
    tool_bucket: "מילוי (Ctrl+F)",
    tool_eyedropper: "טפטפת",
    tool_grid: "רשת (Ctrl+Shift+B)",
    tool_rotate: "סובב (Ctrl+Shift+R)",
    tool_flip_h: "הפוך H (Ctrl+Shift+H)",
    tool_flip_v: "הפוך V (Ctrl+Shift+V)",
    tool_transpose: "העברה (Ctrl+Shift+T)",
    label_width: "רוֹחַב",
    label_height: "גוֹבַה",
    label_frames: "מספר מסגרות",
    label_animation: "סגנון אנימציה",
    label_background_color: "צבע רקע",
    label_interval: "הַפסָקָה",
    tool_anim_config: "תצורת אנימציה",
    label_new_width: "רוחב חדש",
    label_new_height: "גובה חדש",
    label_apply: "לִפְנוֹת",
    label_colors: "צבעים",
    label_size: "גוֹדֶל",
    label_tolerance: "סוֹבלָנוּת",
    val_horizontal: "אופקי",
    val_vertical: "אֲנָכִי",
    val_sequence: "רֶצֶף",
    val_bounce: "לִקְפּוֹץ",
    val_random: "אַקרַאִי",
    val_solid: "מוּצָק",
    val_clear: "בָּרוּר",
    action_add_sheet: "גיליון חדש",
    action_import: "יְבוּא",
    action_export: "יְצוּא",
    action_sort_projects: "סוּג",
    sort_date_old: "הישן ביותר ראשון",
    sort_date_new: "הכי חדש ראשון",
    sort_name_az: "שם (א-ת)",
    sort_name_za: "שם (Z-A)",
    action_new_sprite: "ספרייט חדש",
    action_new_project: "פרויקט חדש",
    modal_save_all_title: "שמור את כל השינויים",
    modal_save_all_desc: "בחר את הנכסים לשמירה:",
    modal_save_selected: "שמור את הבחירה",
    action_saved: "נשמר",
    modal_create_sprite_title: "צור ספרייט חדש",
    modal_create_project_title: "צור פרויקט חדש",
    modal_add_sheet_title: "הוסף גיליון חדש",
    modal_rename_sheet_title: "שנה את שם הגיליון",
    modal_rename_sprite_title: "שנה את שם ספרייט",
    modal_delete_sprite_title: "מחק את ספרייט",
    modal_delete_project_title: "מחק את הפרויקט",
    modal_delete_sheet_title: "מחק גיליון",
    placeholder_sprite_name: "שֵׁם",
    placeholder_project_name: "שֵׁם",
    placeholder_sheet_name: "שֵׁם",
    placeholder_new_name: "שם חדש",
    action_create: "לִיצוֹר",
    action_add: "לְהוֹסִיף",
    action_rename: "שנה שם",
    action_duplicate: "לְשַׁכְפֵּל",
    action_delete: "לִמְחוֹק",
    action_cancel: "לְבַטֵל",
    confirm_delete_sprite: "האם אתה בטוח שברצונך למחוק את הספרייט הזה?",
    confirm_delete_project: "האם אתה בטוח שברצונך למחוק את הפרויקט הזה? כל הספרייטים יוסרו.",
    confirm_delete_sheet: "האם אתה בטוח שברצונך למחוק את הגיליון הזה?",
    err_select_sprite: "אנא בחר ספרייט תחילה.",
    err_select_project: "אנא בחר פרויקט תחילה.",
    err_name_empty: "השם לא יכול להיות ריק.",
    err_sprite_exists: "ספרייט בשם זה כבר קיים.",
    err_project_exists: "פרויקט בשם זה כבר קיים.",
    err_no_content: "אין תוכן לשמור.",
    err_no_changes: "אין שינויים לשמירה.",
    err_delete_last_sheet: "לא ניתן למחוק את הגיליון האחרון.",
    err_extract_frames: "לא ניתן היה לחלץ מסגרות.",
    err_indexeddb: "השמירה המקומית נכשלה. ייתכן שהדפדפן שלך לא תומך ב- IndexedDB.",
    msg_upload_success: "העלאה הצליחה: {0}",
    msg_upload_failed: "ההעלאה נכשלה: {0}",
    msg_save_success: "שמירה מוצלחת.",
    msg_saving: "חִסָכוֹן...",
    msg_multi_save_result: "שמירת {0} נכסים. {1} כשלים.",
    menu_title: "תַפרִיט",
    menu_save: "לְהַצִיל",
    menu_save_all: "שמור הכל",
    menu_support: "צור קשר עם התמיכה",
    label_local_storage: "אחסון מקומי",
    label_sign_in: "היכנס",
    modal_export_title: "ייצוא ספרייט",
    label_filename: "שם הקובץ",
    label_format: "פוּרמָט",
    action_export_confirm: "יְצוּא",
};

export default translations;
